import React from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import { Toast,ToastContainer } from "react-bootstrap";

function ListaPreciosConvenio() {

    const [items, setItems] = useState([]);
    const [userId, setUserId] = useState();

    const [idItemEliminar, setIdItemEliminar] = useState();
    const [modalContainerStatus,setModalContainerStatus] = useState('');
    const [modalBackdropStatus,setModalBackdropStatus] = useState('zindex-back');

    let userdata = [];

    const [empresas, setEmpresas] = useState([]);
    const [convenios, setConvenios] = useState([]);
    const [convenioDefecto, setConvenioDefecto] = useState(0);

    const [empresa, setEmpresa] = useState();
    const [convenio, setConvenio] = useState();
    const [listaPrecios, setListaPrecios] = useState([]);

    const [terminoBusqueda, setTerminoBusqueda] = useState('');

    const [toastMsg, setToastMsg] = useState('');
    const [showToast, setShowToast] = useState(false);

    let pesos = Intl.NumberFormat("es-CO", {
        style: "currency",
        currency: "COP",
    });

    const cols = [
        /*{ name:'Código', selector:row => row.codigo, sortable:true },*/
        { name:'Producto o Servicio', selector:row => row.producto, sortable:true },
        { name:'Precio', selector:row => pesos.format(row.precio), sortable:true },
        { name:'Precio en convenio', cell:row => getBotonPrecioConvenio(row), sortable:false },
        /*{ name:'Precio en convenio', selector:row => row.precio_convenio, sortable:true },*/
        { name:'Descuento', selector:row => row.porcentaje, sortable:false },
        { name:'Precio con descuento', selector:row => getPrecioConDescuento(row), sortable:true },
        /*{ name:'Precio con descuento', selector:row => (row.precio_con_descuento ? row.precio_con_descuento : row.precio_convenio ), sortable:true },*/
        /*{ name:'Acción', cell:row => getBotones(row), minWidth: '15%' }*/
    ];

    const getBotones = (item) => {
        
        return (
            <>
            <Link to={'/precio-convenio?id='+item.id} className="btn btn-primary btn-sm"><i className="far fa-edit"></i>&nbsp;Editar</Link>&nbsp;
            </>
        )
    }

    const getBotonPrecioConvenio = (item) => {

        if (item.precio_convenio) {
            return <><span>{pesos.format(item.precio_convenio)}</span><span>&nbsp;</span><Link to={'editar-precio-convenio?id='+item.precio_convenio_id+'&prodid='+item.producto_id+'&convid='+convenio} className="btn btn-primary btn-xs">Editar</Link></>;
            
        }
        else {
            return <Link to={'nuevo-precio-convenio?id='+item.producto_id+'&convid='+convenio} className="btn btn-primary btn-sm">Configurar</Link>
        }
    }


    const getPrecioConDescuento = (item) => {
        
        return item.precio_convenio ? item.precio_convenio : item.precio_con_descuento;
    }

    useEffect(()=>{

        if (localStorage.getItem('nuevo_precio_convenio')) {
            const nuevoPrecio = JSON.parse(localStorage.getItem('nuevo_precio_convenio'));
            setToastMsg('Se ha creado un nuevo precio de "'+nuevoPrecio.producto+'" en el convenio "'+nuevoPrecio.convenio+'"');
            localStorage.removeItem('nuevo_precio_convenio');
            setTimeout(() => { setShowToast(true) },800);
        }

        if (localStorage.getItem('edit_precio_convenio')) {
            const editPrecio = JSON.parse(localStorage.getItem('edit_precio_convenio'));
            setToastMsg('Se ha modificado el precio de "'+editPrecio.producto+'" en el convenio "'+editPrecio.convenio+'"');
            localStorage.removeItem('edit_precio_convenio');
            setTimeout(() => { setShowToast(true) },800);
        }

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
            setUserId(userdata.user_id);
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }

        axios.get('/empresas?uid='+userdata.user_id, config)
            .then(response => {
                if (response.status===200) {
                    setEmpresas(response.data);
                }
            })
            .catch(error => {
                console.log(JSON.stringify(error));
            });

    },[]);


    useEffect(() => {
        
        const config = {
            params: {
                empresa_id: empresa
            }
        }
        
        axios.get('/convenios-empresa',config)
            .then(
                response => {
                    setConvenios(response.data);
                    setConvenio(0);
                    setListaPrecios([]);
                }
            )
            .catch(
                err => {
                    setListaPrecios([]);
                    console.log(err.response.data.errors)
                }
            )

    },[empresa]);


    useEffect(() => {
        
        const config = {
            params: {
                uid: userId,
                convenio_id: convenio
            }
        }

        axios.get('/precios-convenio',config)
            .then(
                response => {
                    setListaPrecios(response.data);
                }
            )
            .catch(
                err => {
                    setListaPrecios([]);
                    console.log(err.response.data.errors)
                }
            )

    },[convenio]);


    const showModal = (e) => {
        setModalContainerStatus('show');
        setModalBackdropStatus('show');
        setIdItemEliminar(e);
    }

    const cerrar = () => {
        setModalContainerStatus('');
        setModalBackdropStatus('zindex-back');
        setIdItemEliminar(null);
    }


    useEffect(() => {
        
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                uid: userdata.user_id,
                termino: terminoBusqueda,
                convenio_id: convenio
            }
        }

        axios.get('/precios-convenio',config)
            .then(
                response => {
                    setListaPrecios(response.data);
                }
            )
            .catch(
                err => {
                    setListaPrecios([]);
                    console.log(err.response.data.errors)
                }
            )

    },[terminoBusqueda]);


    return (
        
        <div className="hold-transition">
            <Header />
            <Aside activelink="settings" />
            
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-8">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                    <li className="breadcrumb-item" key="bc2"><Link to="/settings">Configuración</Link></li>
                                    <li className="breadcrumb-item" key="bc3"><Link to="/administrar-convenios">Administrar Empresas y Convenios</Link></li>
                                    <li className="breadcrumb-item" key="bc4">Listas de Precios</li>
                                </ol>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-sm-8">
                                <h1 className="m-0">Listas de Precios</h1>
                            </div>
                        </div>
                    </div>
                </div>
                <section className="content" >
                    <div className="container-fluid">

                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div id="infobasica">
                                    <div className="card-body">

                                            <div className="row">
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label htmlFor="empresa">Empresa</label>
                                                        <select name="empresa" className="form-control" id="empresa" onChange={(e) => setEmpresa(e.target.value)}>
                                                            <option value="0"></option>
                                                            {
                                                                empresas.map((empresa) =>
                                                                    <option value={empresa.id}>{empresa.nombre_empresa}</option>   
                                                                )
                                                            }
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label htmlFor="convenio">Convenio</label>
                                                        <select name="convenio" id="convenio" className="form-control" value={convenio} onChange={(e) => setConvenio(e.target.value)}>
                                                            <option value="0"></option>
                                                            {
                                                                convenios.map((convenio) => 
                                                                    <option value={convenio.id}>{convenio.id} - {convenio.nombre}</option>
                                                                )
                                                            }
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label htmlFor="nombre">Buscar por nombre</label>
                                                        <input type="text" id="busquedaNombre" name="busquedaNombre" class="form-control" onChange={(e) => setTerminoBusqueda(e.target.value)} />
                                                    </div>
                                                </div>
                                            </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            
                            <DataTable
                            columns={cols}
                            data={listaPrecios}
                            pagination
                            id={'listaprecios'}
                            />

                        </div>          
                    </div>

                    </div>
                </section>
            </div>

            
            <div className={'modal-backdrop fade '+modalBackdropStatus}></div>

            <ToastContainer className="toast-exito">
                <Toast onClose={() => setShowToast(false)} show={showToast} delay={4000} autohide>
                    <Toast.Body>{toastMsg}</Toast.Body>
                </Toast>
            </ToastContainer>
            
            <Footer showToast={false} delay={0} />
        </div>
    );
}
export default ListaPreciosConvenio;